// @flow

import type { AuthBloc } from "../../blocs/authBloc";
import { apiAxios } from '../../config/AxiosConfig'
import type { CreatePaymentRequest, UpdatePaymentRequest, Payment } from "../../models/Payment/Payment";

class PaymentApi {

  authBloc: AuthBloc;

  constructor(authBloc: AuthBloc) {
    this.authBloc = authBloc;
  }

  async getPaymentsForProject(projectId: string): Promise<Array<Payment>> {
    const tenantId = this.authBloc.getCurrentTenant();

    const response = await apiAxios.get(`/tenants/${tenantId}/projects/${projectId}/payments`, this.buildHeaders());

    if (response.status === 200) {
      const data = response.data;
      const homeowner = data.homeowner;
      const homeownerName = homeowner
        ? `${homeowner.firstName || ''} ${homeowner.lastName || ''}`.trim()
        : null;

      const payments = data.payments || [];
      return payments.map(payment => ({
        ...payment,
        homeownerName: payment.homeownerName || homeownerName,
      }));
    } else {
      throw new Error(response.status);
    }
  }

  async createPayment(createPaymentRequest: CreatePaymentRequest): Promise<Payment> {
    const tenantId = this.authBloc.getCurrentTenant();

    let payload;
    if (createPaymentRequest.attachment) {
      payload = createPaymentRequest.attachment.payload;
      delete createPaymentRequest.attachment.payload;
    }

    const response = await apiAxios.post(`/tenants/${tenantId}/projects/${createPaymentRequest.projectId}/payments`, createPaymentRequest, this.buildHeaders());

    if (createPaymentRequest.attachment)
      createPaymentRequest.attachment.payload = payload;

    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(response.status);
    }
  }

  async deletePayment(projectId: string, paymentId: string): Promise<void> {
    const tenantId = this.authBloc.getCurrentTenant();

    const response = await apiAxios.delete(`/tenants/${tenantId}/projects/${projectId}/payments/${paymentId}`, this.buildHeaders());

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.status);
    }
  }

  async updatePayment(updatePaymentRequest: UpdatePaymentRequest): Promise<Payment> {
    const tenantId = this.authBloc.getCurrentTenant();

    let payload;
    if (updatePaymentRequest.attachment) {
      payload = updatePaymentRequest.attachment.payload;
      delete updatePaymentRequest.attachment.payload;
    }

    const response = await apiAxios.patch(`/tenants/${tenantId}/projects/${updatePaymentRequest.projectId}/payments/${updatePaymentRequest.id}`, updatePaymentRequest, this.buildHeaders());

    if (updatePaymentRequest.attachment)
      updatePaymentRequest.attachment.payload = payload;

    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(response.status);
    }
  }

  buildHeaders = () => {
    const accessToken = this.authBloc.getCurrentToken();
    const auth = "Bearer " + accessToken;
    return { headers: { Authorization: auth } };
  }
}

export default PaymentApi;
